import { useRef } from 'react';
import { DefaultRootState, useSelector } from 'react-redux';

/**
 * Returns the latest value from a Redux selector, unless `shouldStick` is true in which case it holds on to the current value.
 */
const useStickySelector = <T>(selector: (state: DefaultRootState) => T, shouldStick: boolean): T => {
    const latestValue = useSelector(selector);
    const valueRef = useRef<T>(latestValue);

    if (!shouldStick) {
        valueRef.current = latestValue;
    }

    return valueRef.current;
};

export default useStickySelector;
